import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

import { SpeakersListComponent } from 'projects/speaker-platform/src/app/organisms/speakers-list/speakers-list.component';
import { AtsappService } from '@common/services/atsapp.service';
import { Speaker } from 'projects/speaker-platform/src/app/types/speaker';

@Component({
  selector: 'app-messagerie',
  imports: [SpeakersListComponent],
  templateUrl: './messagerie.component.html',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./messagerie.component.scss']
})
export class MessagerieComponent implements OnInit {
  constructor(private atsappService: AtsappService) {}
  speakers: any[] = [];

  ngOnInit(): void {
    this.atsappService.getSpeakers(false).subscribe((res: any) => {
      this.speakers = res;
    })
  }

  selectSpeaker(e: Speaker): void {
  }
}
